export default __webpack_public_path__ + "static/media/Done_ring_round_light.15247304.svg";